import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { Package, Luggage, ArrowRight, Euro, Truck } from "lucide-react";

const articles = [
  {
    slug: "/transport-colis-france-maroc",
    title: "Transport de Colis France – Maroc : Le Guide Complet",
    description: "Tout savoir sur le transport de colis entre la France et le Maroc : options, délais, tarifs, réglementation douanière et conseils pratiques.",
    icon: Package,
    category: "Guide",
    readTime: "8 min",
  },
  {
    slug: "/transport-bagages-france-maroc",
    title: "Transport de Bagages France – Maroc : Guide Pratique",
    description: "Guide complet pour le transport de bagages entre la France et le Maroc : valises, effets personnels, déménagement léger.",
    icon: Luggage,
    category: "Guide",
    readTime: "7 min",
  },
  {
    slug: "/prix-transport-colis-maroc",
    title: "Prix Transport Colis France Maroc – Tarifs et Estimation",
    description: "Découvrez les prix du transport de colis entre la France et le Maroc. Fourchettes tarifaires, facteurs de variation et comparatif des solutions.",
    icon: Euro,
    category: "Tarifs",
    readTime: "6 min",
  },
  {
    slug: "/envoyer-colis-maroc-pas-cher",
    title: "Envoyer un Colis au Maroc Pas Cher – Guide et Solutions",
    description: "Comment envoyer un colis au Maroc pas cher en toute sécurité ? Erreurs à éviter, risques et solutions fiables.",
    icon: Truck,
    category: "Économie",
    readTime: "5 min",
  },
];

const Blog = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Helmet>
        <title>Blog – Guides Transport Colis France Maroc | GoBledPro</title>
        <meta 
          name="description" 
          content="Guides et conseils pour vos envois de colis et bagages entre la France et le Maroc. Tarifs, délais, réglementation et bonnes pratiques." 
        />
        <link rel="canonical" href="https://gobledpro.com/blog" />
        <meta property="og:title" content="Blog – Guides Transport Colis France Maroc | GoBledPro" />
        <meta property="og:description" content="Guides et conseils pour vos envois de colis et bagages entre la France et le Maroc." />
        <meta property="og:image" content="https://gobledpro.com/og-blog.png" />
        <meta property="og:url" content="https://gobledpro.com/blog" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="GoBledPro" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://gobledpro.com/og-blog.png" />
      </Helmet>
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
                Blog
              </h1>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Guides et conseils pour vos envois entre la France et le Maroc.
              </p>
            </div>

            {/* Articles Grid */}
            <div className="grid gap-6">
              {articles.map((article) => (
                <Link
                  key={article.slug}
                  to={article.slug}
                  className="group block bg-card border border-border rounded-2xl p-6 hover:border-primary/30 hover:shadow-lg transition-all duration-300"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                      <article.icon className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded-full">
                          {article.category}
                        </span>
                        <span className="text-xs text-muted-foreground">
                          {article.readTime} de lecture
                        </span>
                      </div>
                      <h2 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                        {article.title}
                      </h2>
                      <p className="text-muted-foreground text-sm line-clamp-2">
                        {article.description}
                      </p>
                      <div className="flex items-center gap-1 mt-4 text-sm font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity">
                        Lire l'article
                        <ArrowRight className="w-4 h-4" />
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
